import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "error-widget",
  class: "pl-3 pr-3 fixed-bottom"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "error-message" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass((_ctx.isVisible ? 'show' : 'hide') + ' alert ' + _ctx.alertClass + ' alert-dismissible fade'),
          role: "alert"
        }, [
          (_ctx.isError && _ctx.statusCode > 200)
            ? (_openBlock(), _createElementBlock("strong", _hoisted_2, "Error " + _toDisplayString(_ctx.statusCode) + " " + _toDisplayString(_ctx.statusText) + ":", 1))
            : _createCommentVNode("", true),
          _cache[4] || (_cache[4] = _createTextVNode()),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.message), 1),
          (_ctx.isHttp401)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [...(_cache[1] || (_cache[1] = [
                _createTextVNode("You seem to be signed out. Please ", -1),
                _createElementVNode("a", { href: "/signin" }, "sign in", -1),
                _createTextVNode(".", -1)
              ]))]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("span", null, "×", -1)
          ]))]),
          (_ctx.isError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("a", { href: "/about/contacts" }, "Contact us", -1),
                _createTextVNode(" if this error persists. ", -1)
              ]))]))
            : _createCommentVNode("", true)
        ], 2)
      ]))
    : _createCommentVNode("", true)
}